"use client";

import { useQuery } from "@tanstack/react-query";
import { gql, request } from "graphql-request";
import { ENVIO_GRAPHQL_ENDPOINT } from "@/constants/api";

interface HenloHolderStats {
  id: string;
  chainId: number;
  uniqueHolders: number;
  totalSupply: string;
  lastUpdateTime: string;
}

const GET_HOLDER_STATS_QUERY = gql`query GetHolderStats { HenloHolderStats(where: { chainId: { _eq: 80094 } }) { id chainId uniqueHolders totalSupply lastUpdateTime } }`;

export function useHolderStats() {
  return useQuery({
    queryKey: ["henlo", "holders", "stats"],
    queryFn: async () => {
      const data = await request<{ HenloHolderStats: HenloHolderStats[] }>(
        ENVIO_GRAPHQL_ENDPOINT,
        GET_HOLDER_STATS_QUERY,
      );
      const stats = data.HenloHolderStats[0];
      return {
        uniqueHolders: stats?.uniqueHolders || 0,
        totalSupply: stats?.totalSupply || "0",
        lastUpdateTime: stats?.lastUpdateTime || "0",
      };
    },
    refetchInterval: 120000,
    staleTime: 60000,
    gcTime: 10 * 60 * 1000,
  });
}
